var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtriasLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AF2024;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    className: "st0",
    d: "M142.07,127.08v46.96H88.44v48.79H41.48v-95.75H142.07z M214.79,33.75v190.29h-47.18V81.05H88.66 v15.87H41.48V33.75H214.79z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtriasLogo);
export default __webpack_public_path__ + "static/media/atrias-logo.8b2d2337d88659a93caa9610f2ec71cb.svg";
export { ForwardRef as ReactComponent };